<ion-content no-bounce padding-horizontal>
  @if (!isOnline()) {
    <div class="error-network">
      <span class="error-network-container">
        <i class="icon-warning"></i>
        <span>{{"NoAccessInternet" | translate}}</span>
      </span>
    </div>
  } @else if (isLoading()) {
    <div class="loading-container">
      <ion-spinner name="lines"></ion-spinner>
    </div>
  } @else {
    <app-header
      [iconName]="'menu'"
      [title]="null"
      [menuToggleRight]="true"
      [showErrorMessageNetwork]="true">
    </app-header>
    <h1 class="signin-title">
      {{"SignIn" | translate}}
    </h1>

    @if (errorMessage) {
      <div class="error-message-container mb20"  error-message-container>
        {{errorMessage | translate}}
      </div>
    }

    @if (!showTenantDomainInput) {
      <ion-grid>
        <ion-row class="ion-align-items-center">
          <ion-col size="12" class="ion-text-center">
            <ion-button class="login-button mt20"
            type="button"
            fill="outline"
            expand="block"
            [disabled]="authWaiting()"
            (click)="goToSignInApp('id_ms')">
              <span>
                <i>
                  <svg class="icon-microsoft" width="24px" height="24px" viewBox="44 129 24 24" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="microsoft-logo" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                    transform="translate(44.000000, 129.000000)">
                      <rect id="1" fill="#F65314" x="0" y="0" width="11.5121951" height="11.5121951"></rect>
                      <rect id="2" fill="#7CBB00" x="12.4878049" y="0" width="11.5121951" height="11.5121951"></rect>
                      <rect id="3" fill="#FFBB00" x="12.4878049" y="12.4878049" width="11.5121951"
                      height="11.5121951"></rect>
                      <rect id="4" fill="#00A1F1" x="0" y="12.4878049" width="11.5121951" height="11.5121951"></rect>
                    </g>
                  </svg>
                </i>
                <span class="button-text">
                  {{"SignInWithWindows" | translate}}
                </span>
              </span>
            </ion-button>
            <ion-button class="login-button"
            type="button"
            fill="outline"
            expand="block"
            [disabled]="authWaiting()"
            (click)="goToSignInApp('id_google')">
              <span>
                <i>
                  <svg class="icon-google" width="24px" height="24px" viewBox="0 0 23 24" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="btn_google_light_normal_ios">
                      <g id="logo_googleg_48dp" transform="translate(0.709091, 0.709091)">
                        <path
                        d="M22.1301818,11.5475207 C22.1301818,10.7468926 22.0583306,9.97705785 21.9248925,9.23801652 L11.2909091,9.23801652 L11.2909091,13.6055455 L17.3674711,13.6055455 C17.1057273,15.0169091 16.3102314,16.212719 15.1144215,17.0133471 L15.1144215,19.8463389 L18.763438,19.8463389 C20.8984463,17.8806942 22.1301818,14.9861156 22.1301818,11.5475207 L22.1301818,11.5475207 Z"
                        id="Shape" fill="#4285F4" fill-rule="nonzero"></path>
                        <path
                        d="M11.2909091,22.5818182 C14.3394545,22.5818182 16.8953058,21.5707686 18.763438,19.8463389 L15.1144215,17.0133471 C14.1033719,17.6908016 12.8100496,18.0911156 11.2909091,18.0911156 C8.35014049,18.0911156 5.86100826,16.1049421 4.97313223,13.4361818 L1.20094215,13.4361818 L1.20094215,16.3615537 C3.05880992,20.0516281 6.87719008,22.5818182 11.2909091,22.5818182 L11.2909091,22.5818182 Z"
                        id="Shape" fill="#34A853" fill-rule="nonzero"></path>
                        <path
                        d="M4.97313223,13.4361818 C4.74731405,12.7587273 4.61900826,12.0350826 4.61900826,11.2909091 C4.61900826,10.5467355 4.74731405,9.82309091 4.97313223,9.14563636 L4.97313223,6.22026447 L1.20094215,6.22026447 C0.43623967,7.74453719 0,9.46896694 0,11.2909091 C0,13.1128512 0.43623967,14.837281 1.20094215,16.3615537 L4.97313223,13.4361818 L4.97313223,13.4361818 Z"
                        id="Shape" fill="#FBBC05" fill-rule="nonzero"></path>
                        <path
                        d="M11.2909091,4.49070247 C12.9486198,4.49070247 14.436967,5.06038016 15.6071156,6.17920662 L18.8455537,2.9407686 C16.8901735,1.11882645 14.3343223,0 11.2909091,0 C6.87719008,0 3.05880992,2.53019008 1.20094215,6.22026447 L4.97313223,9.14563636 C5.86100826,6.47687603 8.35014049,4.49070247 11.2909091,4.49070247 L11.2909091,4.49070247 Z"
                        id="Shape" fill="#EA4335" fill-rule="nonzero"></path>
                        <polygon id="Shape" points="0 0 22.5818182 0 22.5818182 22.5818182 0 22.5818182"></polygon>
                      </g>
                    </g>
                  </g>
                </svg>
              </i>
              <span class="button-text">
                {{"SignInWithGoogle" | translate}}
              </span>
              </span>
            </ion-button>
            <ion-button class="login-button"
              type="button"
              fill="clear"
              center
              expand="block"
              [disabled]="authWaiting()"
              (click)="showInputForTenantDomain()">
              <span class="button-text">
                {{'AlternateSignIn' | translate}}
              </span>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    } @else {
      @if (showTenantDoesNotExist() || showTenantCouldNotBeLoaded()) {
          <div class="text-center color-danger">
            @if (showTenantCouldNotBeLoaded()) {<div>Error code: {{errorStatus}}</div>}
            {{'TenantDoesNotExist' | translate | stringular: 'Printix' : (userInputTenantDomain || '') }}
          </div>
        } @else if (showTenantIsDeactivated()) {
          <div class="text-center color-danger">
            {{'TenantIsDeactivated' | translate | stringular: 'Printix' : (userInputTenantDomain || '') }}
          </div>
        }

      <form class="other-methods-form" action="" (ngSubmit)="validateUserDomainInput()">
        <fieldset class="form-section">
          <div class="form-group form-group-lg tenant-domain-input">
            <span class="input-wrapper">
              <input class="form-control--inline width70"
                [ngClass]="{'loading': showTenantNameSpinner()}"
                name="onelogin"
                type="text"
                (input)="hideErrorText($event)"
                [(ngModel)]="userInputTenantDomain"
                placeholder="{{'MyPrintixHome' | translate | stringular: 'Printix'}}"
                required
              />
              @if (userInputTenantDomain && !showTenantNameSpinner()) {
                <button type="button" class="clear-input-btn" (click)="clearTenantInput()" aria-label="Clear input">
                  <ion-icon name="close" size="small"></ion-icon>
                </button>
              }
              <ion-spinner class="input-spinner" name="lines" [hidden]="!showTenantNameSpinner()"></ion-spinner>
            </span>
            <span class="printix-url ml10 mt5 width25">.printix.net</span>

            <button
              class="btn btn-primary width40 mt30"
              type="submit"

              block
              [disabled]="!userInputTenantDomain || showTenantDoesNotExist() || showTenantIsDeactivated() || showTenantCouldNotBeLoaded()">
              {{"Ok" | translate}}
            </button>
          </div>
        </fieldset>
      </form>

      <a class="btn btn-block btn-link back-button"
        role="button"
        (click)="goBackToMainSignIn()">
        {{"Back"| translate}}
      </a>
    }
  }
</ion-content>

